:host {
  display: flex;
  min-height: calc(var(--space-unit) * 2.5);
  align-items: start;
  margin-top: var(--space-unit);
  color: var(--color-text05);
  fill: currentcolor;
  font-family: var(--font-family-sans);
  font-size: var(--font-size-2);
  letter-spacing: 0.16px;
}

:host(.small),
:host(.x-small) {
  margin-top: calc(var(--space-unit) * 0.5);
  font-size: var(--font-size-1);
}

:host([status="success"]) {
  color: var(--color-text-success);
}

:host([status="error"]) {
  color: var(--color-text-error);
}

:host([status="warning"]) {
  color: var(--color-warning02);
}

:host(:focus) {
  outline: none;
}

:host > z-icon {
  --z-icon-width: calc(var(--space-unit) * 2);
  --z-icon-height: calc(var(--space-unit) * 2);
  --z-icon-right-margin: var(--space-unit);

  margin-top: calc(var(--space-unit) * 0.25);
}

:host(.small) > z-icon,
:host(.x-small) > z-icon {
  --z-icon-width: 14px;
  --z-icon-height: 14px;
  --z-icon-right-margin: calc(var(--space-unit) * 0.5);
}
